import { render } from "./SoftSkill.vue?vue&type=template&id=1d740401&scoped=true"
import script from "./SoftSkill.vue?vue&type=script&lang=js"
export * from "./SoftSkill.vue?vue&type=script&lang=js"

import "./SoftSkill.vue?vue&type=style&index=0&id=1d740401&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d740401"]])

export default __exports__